import { render } from "./PrivatePage.vue?vue&type=template&id=0e82d0da"
import script from "./PrivatePage.vue?vue&type=script&lang=js"
export * from "./PrivatePage.vue?vue&type=script&lang=js"

import "./PrivatePage.vue?vue&type=style&index=0&id=0e82d0da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__